import { h } from "@stencil/core";
import { BEM } from "../../../utils/bem";
export const AccordionButton = ({ id, label, level, open, link, href, target, onClick, }) => {
    const block = BEM.block('nav');
    return link ? (h("a", { id: id, class: Object.assign({}, block.element(`mobile-${level}-item`).class()), href: href, target: target, onClick: ev => onClick(ev) }, h("span", null, label))) : (h("button", { id: id, class: Object.assign({}, block.element(`mobile-${level}-item`).class()), onClick: ev => onClick(ev) }, h("span", null, label), h("bal-icon", { name: "nav-go-down", size: "small", turn: open })));
};
